import { NAME } from './constants';
export const SEARCH_SUGGESTIONS = `${NAME}/SEARCH_SUGGESTIONS`;

export const searchSuggestions = locale => ({
  type: SEARCH_SUGGESTIONS,
  payload: {
    locale,
  },
});
